import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Router } from '@angular/router'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { Observable } from 'rxjs'
import { ChangeCustAccountService } from '../change-cust-account.service'

@Component({
  standalone: false,
  selector: 'vs-change-cust-account',
  templateUrl: './change-cust-account.component.html',
  styleUrls: ['./change-cust-account.component.scss'],
})
export class ChangeCustAccountComponent implements OnInit {
  searchText: string
  public b2BAccount: any
  term = ''
  public name: string
  public userId: string
  public address: string
  public selectId: boolean
  public showEntity: boolean = false
  loading = true
  public legalEntitisList
  public defaultEntity
  public recents
  public favourite
  public recents$: Observable<any>
  public favourite$: Observable<any>
  public myHeight
  public searchDone: boolean
  public b2BAccount$: Observable<any>
  public changeLegalEntity: boolean
  public searchList$: Observable<any>
  public searchList
  public changeFlag
  public myWidth
  public maxHeight
  public Width
  public entityUid
  public maxHeightSearch
  public favorite: boolean
  @Output()
  closeSideNav = new EventEmitter<any>()
  @Input()
  width

  companies = [
    {
      accountno: 10745,
      name: 'EASTERN CONTROLS INC',
      select: true,
    },
    {
      accountno: 20680,
      name: 'SETPOINT INTEGRATED SOLUTIONS',
    },
    {
      accountno: 300,
      name: 'DRESSER PRODUITS INDUSTRIELS SAS',
    },
    {
      accountno: 100,
      name: 'Coimbatore, India - GE Oil & Gas India Private Limited, INR( ₹ )',
    },
    {
      accountno: 200,
      name: 'customer 2',
    },
    {
      accountno: 300,
      name: 'customer 4',
    },
    {
      accountno: 400,
      name: 'customer 3',
    },
    {
      accountno: 500,
      name: 'customer 6',
    },
    {
      accountno: 600,
      name: 'customer 9',
    },
    {
      accountno: 700,
      name: 'customer 9',
    },
  ]
  constructor(
    private router: Router,
    private changeCustAccountService: ChangeCustAccountService,
    private globalMessageService: GlobalMessageService
  ) {
    this.changeLegalEntity = false
    this.searchDone = false
  }

  ngOnInit() {
    if (this.width) {
      this.myWidth = 100
      this.Width = 745
    }
    this.myHeight = document.body.offsetHeight - 78 - 22 - 20
    this.maxHeight = this.myHeight - 26 - 20 - 97 - 36 - 22 - 48 - 80
    this.recents$ = this.changeCustAccountService.getRecent()
    this.recents$.subscribe(
      (recentRes) => {
        this.recents = recentRes
      },
      (error) => {
        /* this.globalMessageService.add(
        error,
        GlobalMessageType.MSG_TYPE_ERROR,
        5000
      );
      window.scrollTo(0, 0); */
      }
    )
    this.favourite$ = this.changeCustAccountService.getFavorite()
    this.favourite$.subscribe(
      (favRes) => {
        this.favourite = favRes
      },
      (error) => {
        /* this.globalMessageService.add(
        error,
        GlobalMessageType.MSG_TYPE_ERROR,
        5000
      );
      window.scrollTo(0, 0); */
      }
    )
    this.b2BAccount$ = this.changeCustAccountService.getCustomerAccDetails()
    this.b2BAccount$.subscribe(
      (res) => {
        this.b2BAccount = res
        for (let i = 0; i < this.b2BAccount?.b2bUnits?.length; i++) {
          if (this.b2BAccount.b2bUnits[i].isDefaultB2bUnit) {
            this.name = this.b2BAccount.b2bUnits[i].name
            this.userId = this.b2BAccount.b2bUnits[i].uid
            this.favorite = this.b2BAccount.b2bUnits[i].isFavouriteB2BUnit
            this.changeCustAccountService
              .getLegalEntities(this.userId)
              .subscribe((res) => {
                this.legalEntitisList = res
                for (
                  let i = 0;
                  i < this.legalEntitisList?.vsSalesArea?.length;
                  i++
                ) {
                  if (
                    this.legalEntitisList.vsSalesArea[i].isDefaultVsSalesArea
                  ) {
                    this.defaultEntity =
                      this.legalEntitisList.vsSalesArea[i].salesOrganization
                    this.entityUid = this.legalEntitisList.vsSalesArea[i].uid
                  }
                }
              })
          }
          for (
            let j = 0;
            j < this.b2BAccount?.b2bUnits[i]?.vsSalesArea?.length;
            j++
          ) {
            if (
              this.b2BAccount.b2bUnits[i].vsSalesArea[j].isDefaultVsSalesArea
            ) {
              this.address = `${this.b2BAccount.b2bUnits[i].vsSalesArea[j].salesOrganization} -
            ${this.b2BAccount.b2bUnits[i].vsSalesArea[j].division}`
            }
          }
        }
      },
      (error) => {
        /* this.globalMessageService.add(
        error,
        GlobalMessageType.MSG_TYPE_ERROR,
        5000
      );
      window.scrollTo(0, 0); */
      }
    )
  }

  changeEntity() {
    this.showEntity = true
    this.changeFlag = true
  }
  close() {
    this.closeSideNav.emit(false)
    this.myWidth = 0
    this.Width = 0
  }
  selectRecent(company) {
    this.selectId = true
    this.changeLegalEntity = true
    this.name = company.name
    this.favorite = company.isFavouriteB2BUnit
    this.userId = company.uid
    this.address = ''
    this.showEntity = true
    this.changeFlag = true
    this.changeCustAccountService
      .getLegalEntities(this.userId)
      .subscribe((res) => {
        this.legalEntitisList = res
        for (let i = 0; i < this.legalEntitisList?.vsSalesArea?.length; i++) {
          if (this.legalEntitisList.vsSalesArea[i].isDefaultVsSalesArea) {
            this.defaultEntity =
              this.legalEntitisList.vsSalesArea[i].salesOrganization
            this.entityUid = this.legalEntitisList.vsSalesArea[i].uid
          }
        }
      })
  }
  select() {
    alert('add true to select')
  }
  selectedLegalEntity(event) {
    this.showEntity = event
    this.changeLegalEntity = true
    this.b2BAccount$.subscribe(
      (res) => {
        this.b2BAccount = res
        for (let i = 0; i < this.b2BAccount?.b2bUnits?.length; i++) {
          if (this.b2BAccount.b2bUnits[i].isDefaultB2bUnit) {
            this.name = this.b2BAccount.b2bUnits[i].name
            this.userId = this.b2BAccount.b2bUnits[i].uid
          }
          for (
            let j = 0;
            j < this.b2BAccount?.b2bUnits[i]?.vsSalesArea?.length;
            j++
          ) {
            if (
              this.b2BAccount.b2bUnits[i].vsSalesArea[j].isDefaultVsSalesArea
            ) {
              this.address = `${this.b2BAccount.b2bUnits[i].vsSalesArea[j].salesOrganization} -
            ${this.b2BAccount.b2bUnits[i].vsSalesArea[j].division}`
            }
          }
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  modelChange(search) {
    this.searchDone = true
    this.searchList$ = this.changeCustAccountService.searchList(search.value)
    this.searchList$.subscribe(
      (res) => {
        this.searchList = res
        this.maxHeightSearch =
          this.myHeight - 26 - 20 - 97 - 36 - 22 - 48 - 80 - 66
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  closePage(event) {
    this.closeSideNav.emit(event)
  }

  keyPress(search) {
    if (search.value.length > 1) {
      this.searchDone = true
      this.searchList$ = this.changeCustAccountService.searchList(search.value)
      this.searchList$.subscribe((res) => {
        this.maxHeightSearch =
          this.myHeight - 26 - 20 - 97 - 36 - 22 - 48 - 80 - 66
      })
    }
  }

  remove() {
    this.favorite = false
    this.changeCustAccountService
      .removeFromFav(this.userId)
      .subscribe((res) => {})
  }

  addToFav() {
    this.favorite = true
    this.changeCustAccountService
      .addToFavourite(this.userId, this.entityUid)
      .subscribe((res) => {})
  }
  tabClick(event, search) {
    if (event.index == 2) this.modelChange(search)
  }
}
